export class ProviderUserAcceptRequest {
  token: string;
}
